module.exports = __webpack_public_path__ + "media/images/give-with-water-df5914a6eece94390d4b6c03d66f0372.svg";